let accessToken = localStorage.getItem("accessToken");
let refreshToken = localStorage.getItem("refreshToken");

export function getAccessToken() {
    return accessToken;
}

export async function requestNewTokens() {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/anonymous-token`, {
        headers: {
            "X-Frontend-Secret": process.env.REACT_APP_FRONTEND_SECRET!
        }
    });

    const data = await res.json();

    accessToken = data.accessToken;
    refreshToken = data.refreshToken;

    localStorage.setItem("accessToken", accessToken!);
    localStorage.setItem("refreshToken", refreshToken!);
}

export async function refreshAccessToken() {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({refreshToken})
    });

    if (!res.ok) return false;

    const data = await res.json();
    accessToken = data.accessToken;
    localStorage.setItem("accessToken", accessToken!);
    return true;
}

